import React from 'react';
import { t } from 'ttag';
import style from './packageBox.scss';
import Price from '../../util/Price';

function PackageDetails(props) {
    const { onClose } = props;
    return (
        <div className={style.packageDetails}>
            <button className={style.closeButton} onClick={props.onClose} type="button">X</button>
            <h2>{props.package.name}</h2>
            <p className={style.detailText}>{props.package.information}</p>
            <h4 className={style.detailNumbers}>
                {props.package.weight} KG +<Price value={props.package.total_price} />
            </h4>
            <button className={style.button} type="button" onClick={onClose}>{t`Fenster schließen`}</button>
        </div>
    );
}

export default PackageDetails;
